import React from "react"

import FeaturedServicesSectionDesktop from "./FeaturedServicesSectionDesktop"
import FeaturedServicesSectionMobile from "./FeaturedServicesSectionMobile"
import ServicesSectionDesktop from "./ServicesSectionDesktop"
import ServicesSectionMobile from "./ServicesSectionMobile"

const ServicesSection = ({
  section,
  practice,
  theme,
  highlightedField,
  pageSlug,
  viewMode = "",
  deviceType = "desktop"
}) => {
  // Determine if we should use featured services layout
  // Featured layouts: double_img_r, double_img_l
  // Regular layouts: list, highlights_2, highlights_3
  const layout = section?.settings?.layout || section?.layout || "list"
  const isFeaturedLayout = ["double_img_r", "double_img_l"].includes(layout)

  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    if (isFeaturedLayout) {
      return (
        <FeaturedServicesSectionMobile
          section={section}
          practice={practice}
          theme={theme}
          highlightedField={highlightedField}
          pageSlug={pageSlug}
        />
      )
    }
    return (
      <ServicesSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  if (viewMode === "desktop") {
    if (isFeaturedLayout) {
      return (
        <FeaturedServicesSectionDesktop
          section={section}
          practice={practice}
          theme={theme}
          highlightedField={highlightedField}
          pageSlug={pageSlug}
        />
      )
    }
    return (
      <ServicesSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    if (isFeaturedLayout) {
      return (
        <FeaturedServicesSectionMobile
          section={section}
          practice={practice}
          theme={theme}
          highlightedField={highlightedField}
          pageSlug={pageSlug}
        />
      )
    }
    return (
      <ServicesSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Default to desktop for desktop devices
  if (isFeaturedLayout) {
    return (
      <FeaturedServicesSectionDesktop
        section={section}
        practice={practice}
        theme={theme}
        highlightedField={highlightedField}
        pageSlug={pageSlug}
      />
    )
  }
  return (
    <ServicesSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  )
}

export default ServicesSection
